import { Insurer } from '@/types/admin-insurer';
import { formatPeriodDisplay } from '@/utils/dateConverter';

interface AdminInsurerInfoProps {
  data: Insurer;
}

const CALC_TYPE_LABELS: Record<number, string> = {
  1: '1回〇〇円　月●回まで',
  2: '1ヵ月上限（限度額）〇〇円',
  3: '1回〇〇円　までて1ヵ月上限（限度額）〇〇円',
};

const AdminInsurerInfo = ({ data }: AdminInsurerInfoProps) => {
  const fields = [
    { label: '保険者番号', value: `${data.insurer_number}-${data.sub_number}` },
    { label: '保険種別', value: data.insurer_type?.name },
    { label: '保険制度', value: data.insurance_kind?.name },
    { label: '保険者名称', value: data.insurer_name },
    { label: '保険者仮名', value: data.insurer_name_kana },
    { label: '部署名', value: data.staff_department },
    { label: '受領委任払い用名称', value: data.delegation_insurer_name },
    {
      label: '郵便番号',
      value: `${data.postal_code1} - ${data.postal_code2}`,
    },
    {
      label: '住所',
      value: `${data.address1 ?? ''}${data.address2 ?? ''}${data.address3 ?? ''}`,
    },
    { label: '電話番号', value: data.telephone },
    {
      label: '適用期間',
      value: formatPeriodDisplay(data.available_from, data.available_to),
    },
    { label: '本人負担', value: `${data.cost_rate ?? 0}割` },
    { label: '家族負担', value: `${data.family_cost_rate ?? 0}割` },
    { label: '請求区分', value: data.medix_claim_type?.name },
  ];

  const scc = data.special_calculation_cost;
  const specialFields = [
    { label: '計算種別', value: scc?.calc_type ? CALC_TYPE_LABELS[scc.calc_type] ?? '' : '' },
    { label: '負担金', value: scc?.limit_amount != null ? String(scc.limit_amount) : '' },
    { label: '月間上限回数', value: scc?.limit_num_month != null ? String(scc.limit_num_month) : '' },
    { label: '月間上限金額', value: scc?.limit_amount_month != null ? String(scc.limit_amount_month) : '' },
    { label: '安い方の負担金を適用', value: scc?.is_adopted_lower_cost ? '適用' : '' },
  ];


  return (
    <section className='space-y-4'>
      <h3 className="text-xl">基本情報</h3>
      <div className="w-full h-[1px]  mt-4 bg-secondary-900" />
      <dl className="grid grid-cols-12 gap-y-2 text-sm">
        {fields.map((item, index) => (
          <div key={index} className="contents">
            <dt className="col-span-2 opacity-80">{item.label}</dt>
            <dd className="col-span-10">{item.value ?? ''}</dd>
          </div>
        ))}
      </dl>
      <h3 className="text-xl">特殊医療助成金</h3>
      <div className="w-full h-[1px]  mt-4 bg-secondary-900" />
      <dl className="grid grid-cols-12 gap-y-2 text-sm">
        {specialFields.map((item, index) => (
          <div key={index} className="contents">
            <dt className="col-span-2 opacity-80">{item.label}</dt>
            <dd className="col-span-10">{item.value ?? ''}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
};

export default AdminInsurerInfo;
